<div class="container-fluid">
  <div class="row">
    <div class="col-md-6">
      <mat-list>
        <mat-list-item> Device name: <span class="ms-2 fw-bold">{{item.name ? item.name : 'N/A'}}</span> </mat-list-item>
        <mat-list-item> Device applied: <span class="ms-2 fw-bold">{{item.target ? item.target : 'N/A'}}</span> </mat-list-item>
        <mat-list-item> Company: <span class="ms-2 fw-bold">{{item.company ? item.company.name : 'N/A'}}</span> </mat-list-item>
        <mat-list-item> Site: <span class="ms-2 fw-bold">{{item.site ? item.site.name + ' ('+ item.site.fullAddress() +')' : 'N/A'}}</span> </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
      @if (item.type) {
        <mat-list>
          <mat-list-item>
            <div class="row w-100">
              <div class="col-md-6">Device type: <span class="ms-2 fw-bold">{{item.type.name}}</span></div>
              <div class="col-md-6">Producer: <span class="ms-2 fw-bold">{{item.type.producer}}</span></div>
            </div>
          </mat-list-item>
          <mat-list-item>
            <div class="row w-100">
              <div class="col-md-6">Type: <span class="ms-2 fw-bold">{{item.type.type}}</span></div>
              <div class="col-md-6">Function: <span class="ms-2 fw-bold">{{item.type.function}}</span></div>
            </div>
          </mat-list-item>
        </mat-list>
      }
    </div>
    <div class="col-md-6">
      <mat-list>
        <mat-list-item> Last communication time: <span class="ms-2 fw-bold">{{item.lastcom ? item.lastcom : 'N/A'}}</span> </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
      @if (item.isMeter()) {
        <mat-list>
          <mat-list-item> Gateway: <span class="ms-2 fw-bold">{{item.parent ? item.parent.name : 'N/A'}}</span> </mat-list-item>
          <mat-list-item> Serial number: <span class="ms-2 fw-bold">{{deviceData.serial ? deviceData.serial : item.getSerialNumber(true)}}</span> <button mat-raised-button class="ms-auto" color="primary" (click)="onClickMeterIdentityBtn()"><mat-icon>sync</mat-icon> Check identity</button> </mat-list-item>
          <mat-list-item>
            Current transformer ratio:
            <span class="ms-2 fw-bold">{{deviceData.primary || deviceData.secondary ? (deviceData.primary +'/'+deviceData.secondary) : item.getCurrentTransformerRatio()}}</span>
            <button mat-raised-button class="ms-auto" color="primary" (click)="onClickCheckPrimerBtn()"><mat-icon>sync</mat-icon> Check primary</button>
            <button mat-raised-button class="ms-1" color="primary" (click)="onClickCheckSeconderBtn()"><mat-icon>sync</mat-icon> Check secondary</button>
          </mat-list-item>
        </mat-list>
      }
      @if (item.isDatalogger()) {
        <mat-list>
          <mat-list-item> IMEI number: <span class="ms-2 fw-bold">{{item.getIMEI(true)}}</span> </mat-list-item>
          <mat-list-item> IP: <span class="ms-2 fw-bold">{{item.getIP()}}</span> <button mat-raised-button class="ms-auto" color="primary" (click)="onClickPingBtn()"><mat-icon>sync</mat-icon> Check identity</button> </mat-list-item>
          @if (deviceData.latecy) {
            <mat-list-item> Ping latecy: <span class="ms-2 fw-bold">{{deviceData.latecy}}</span> </mat-list-item>
          }
          <mat-list-item> Serial number: <span class="ms-2 fw-bold">{{item.getSerialNumber(true)}}</span> </mat-list-item>
          <mat-list-item> Uptime: <span class="ms-2 fw-bold">{{deviceData.uptime ? deviceData.uptime : ''}} {{deviceData.uptimeos ? '(OS: '+deviceData.uptimeos+')' : ''}}</span> <button mat-raised-button class="ms-auto" color="primary" (click)="onUptimeClick()"><mat-icon>sync</mat-icon> Check uptime</button></mat-list-item>
          <mat-list-item> Signal: <span class="ms-2 fw-bold">N/A</span> <button mat-raised-button class="ms-auto" color="primary">Check signal</button> </mat-list-item>
        </mat-list>
      }
    </div>
  </div>
</div>

@if (item.isMeter()) {
  <div>
    <mat-toolbar class="small-bar">
      <span >MODBUS parameters</span>
      <span class="toolbar-spacer"></span>
      <button type="button" mat-raised-button color="accent" (click)="writeAllRegister()"><mat-icon>publish</mat-icon> Write items</button>
      <button type="button" mat-raised-button color="primary" class="ms-2" (click)="requestMeterRegisterReading()"><mat-icon>sync</mat-icon> Read items</button>
    </mat-toolbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Parameter name</th>
                <th>Value in database</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Address</td>
                <td>{{item.getAddress(true)}}</td>
                <td>
                  <button type="button" mat-raised-button color="accent" [disabled]="!item.getAddress()" (click)="writeMeterRegister('address')"><mat-icon>publish</mat-icon> Write item</button>
                </td>
              </tr>
              <tr>
                <td>Baud rate</td>
                <td>{{item.getBaudRate(true)}}</td>
                <td>
                  <button type="button" mat-raised-button color="accent" [disabled]="!item.getBaudRate()" (click)="writeMeterRegister('baud')"><mat-icon>publish</mat-icon> Write item</button>
                </td>
              </tr>
              <tr>
                <td>Parity</td>
                <td>{{item.getParity(true)}}</td>
                <td>
                  <button type="button" mat-raised-button color="accent" [disabled]="!item.getParity()" (click)="writeMeterRegister('parity')"><mat-icon>publish</mat-icon> Write item</button>
                </td>
              </tr>
              <tr>
                <td>Databits</td>
                <td>{{item.getDatabits(true)}}</td>
                <td>
                  <button type="button" mat-raised-button color="accent" [disabled]="!item.getDatabits()" (click)="writeMeterRegister('databit')"><mat-icon>publish</mat-icon> Write item</button>
                </td>
              </tr>
              <tr>
                <td>Stopbits</td>
                <td>{{item.getStopbits(true)}}</td>
                <td>
                  <button type="button" mat-raised-button color="accent" [disabled]="!item.getStopbits()" (click)="writeMeterRegister('stopbit')"><mat-icon>publish</mat-icon> Write item</button>
                </td>
              </tr>
              <tr>
                <td>Read frequency</td>
                <td>{{item.getReadFreq(true)}}</td>
                <td>
                  <button type="button" mat-raised-button color="accent" [disabled]="!item.getReadFreq()" (click)="writeMeterRegister('freq')"><mat-icon>publish</mat-icon> Write item</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        @if (deviceData && deviceData.registers && deviceData.registers.length) {
          <div class="col-md-4">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Register</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                @for (r of deviceData.registers; track r; let i = $index) {
                  <tr>
                    <td>{{meterRegisterLabel[i]}}</td>
                    <td>{{r[0]}}</td>
                    <td>{{r[1]}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (item.isDatalogger()) {
  <div>
    <mat-toolbar class="small-bar">
      <span>MODBUS parameters for serial connection</span>
    </mat-toolbar>
    <mat-list>
      <mat-list-item>
        <div class="row w-100">
          <div class="col-md-6">Baud rate: <span class="ms-2 fw-bold">{{item.getBaudRate(true)}}</span></div>
          <div class="col-md-6">Stopbits: <span class="ms-2 fw-bold">{{item.getStopbits(true)}}</span></div>
        </div>
      </mat-list-item>
      <mat-list-item>
        <div class="row w-100">
          <div class="col-md-6">Parity: <span class="ms-2 fw-bold">{{item.getParity(true)}}</span></div>
          <div class="col-md-6">Databits: <span class="ms-2 fw-bold">{{item.getDatabits(true)}}</span></div>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
}

